import { render, staticRenderFns } from "./Closes.vue?vue&type=template&id=753987bd"
import script from "./Closes.vue?vue&type=script&lang=js"
export * from "./Closes.vue?vue&type=script&lang=js"
import style0 from "./Closes.vue?vue&type=style&index=0&id=753987bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports